// Archivo para manejar el contexto de los CRUD
import React, { createContext, useContext, useState } from 'react'
import {
  createConsumer,
  bulkCreateConsumers,
  compressForAudit,
  uploadCompressedFile,
} from '../services/ConsumerServices'

const CrudContext = createContext()

export const CrudProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({
    create: false,
    update: {},
    delete: {},
  })

  const handleCrudOperation = async (operation, entityType, payload = {}) => {
    if (entityType === 'consumer') {
      switch (operation) {
        case 'create':
          setLoadingStates((prev) => ({ ...prev, create: true }))
          try {
            const result = await createConsumer(payload)
            return result
          } catch (error) {
            console.error('Error al crear consumidor:', error)
            throw error
          } finally {
            setLoadingStates((prev) => ({ ...prev, create: false }))
          }

        case 'bulkUpload':
          if (!payload.rows || !payload.layout)
            throw new Error('Faltan datos de carga masiva')
          try {
            const count = await bulkCreateConsumers(
              payload.rows,
              payload.layout,
              payload.onProgress
            )
            const audit = compressForAudit(payload.rows)
            await uploadCompressedFile({
              product_id: payload.productId,
              file_name: payload.fileName || 'bulk.json',
              original_size_kb: audit.originalSizeKB,
              compressed_data: audit.compressed,
              type: 'bulk_consumer_upload',
            })
            return count
          } catch (error) {
            console.error('Error en carga masiva:', error)
            throw error
          }
        default:
          throw new Error(`Operación no soportada: ${operation}`)
      }
    }

    // Agrega aquí otros tipos de entidad como 'activity', 'client', etc.
    throw new Error(`Entidad no soportada: ${entityType}`)
  }

  return (
    <CrudContext.Provider value={{ handleCrudOperation, loadingStates }}>
      {children}
    </CrudContext.Provider>
  )
}

export const useCrud = () => useContext(CrudContext)
